import type {
  ITCFConsent,
  ITCFSelectedVendorList,
} from "../TCFConsentProvider/types";
import { TCF_VENDOR_CATEGORIES_TYPES } from "../constantsTCF";
import { calculateTCFBaseConsent } from "./calculateTCFBaseConsent";
import { FALSE, TRUE } from "constants/primitives";

/**
 * Check if consentA is equal to consentB
 */
const isTCFConsentEqual = (
  consentA: ITCFConsent = calculateTCFBaseConsent(),
  consentB: ITCFConsent = calculateTCFBaseConsent(),
  vendorsList: ITCFSelectedVendorList
): boolean => {
  let isEqual = TRUE;

  // First check categories
  // Filters categories to search only those with switches
  const availableCategories = TCF_VENDOR_CATEGORIES_TYPES.filter(
    (cat) => cat.hasSwitch
  );

  isEqual = availableCategories.every((category) => {
    const categoryName = category.key;

    // Check if category exist in both consents
    if (
      !consentA.categories[categoryName] ||
      !consentB.categories[categoryName]
    ) {
      return FALSE;
    }

    // Convert category values to array
    const catArrA = Object.entries(consentA.categories[categoryName]);
    const catArrB = Object.entries(consentB.categories[categoryName]);

    // Check if length of values are equal
    if (catArrA.length !== catArrB.length) {
      return FALSE;
    }

    // Check if categories values are equal
    const isEqual = catArrA.every(([id, isAccepted]) => {
      if (consentB.categories[categoryName][id] !== isAccepted) {
        return FALSE;
      }
      return TRUE;
    });

    return isEqual;
  });

  // Then check for vendors
  // Loop through list of all available vendors
  vendorsList.every((vendorID) => {
    // Check if vendor value is same in both cases
    if (consentA.vendors[vendorID] !== consentB.vendors[vendorID]) {
      isEqual = FALSE;
    }

    return TRUE;
  });

  return isEqual;
};

export default isTCFConsentEqual;
